/* PureEthical v27 - pequenas correcoes de comportamento (auditoria out 2026) */
(function () {
  'use strict';

  /* Mega menu: o "top" vinha de calc(var(--ann) + var(--nav)), que nao conta
     com a barra do aviso de envio nem com a segunda linha do cabecalho -
     o painel abria por cima do logo. Mede-se o fundo real do cabecalho. */
  var root = document.documentElement;
  function megaTop() {
    var h = document.querySelector('.site-header');
    if (!h) return;
    var b = Math.max(0, Math.round(h.getBoundingClientRect().bottom));
    root.style.setProperty('--pe-mega-top', b + 'px');
  }
  var tk = false;
  function soon() { if (tk) return; tk = true; requestAnimationFrame(function () { tk = false; megaTop(); }); }
  document.addEventListener('mouseover', function (e) {
    if (e.target.closest && e.target.closest('.nav-item, .site-header')) megaTop();
  }, { passive: true });
  document.addEventListener('focusin', function (e) {
    if (e.target.closest && e.target.closest('.site-header')) megaTop();
  });
  window.addEventListener('scroll', soon, { passive: true });
  window.addEventListener('resize', soon, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', megaTop); else megaTop();
  window.addEventListener('load', megaTop);
  /* o aviso de envio e inserido depois do carregamento e empurra o cabecalho */
  if ('MutationObserver' in window) {
    new MutationObserver(soon).observe(document.body, { childList: true });
  }
})();

/* v36 - TELEMOVEL: ESCOLHER A COR LEVA LOGO AS FOTOS
   No telemovel as cores ficam por baixo das fotos. Quem escolhia outra cor
   tinha de descer para a escolher e voltar a subir para ver as fotos novas.
   Agora, ao tocar numa cor (miniatura ou janela "Ver todas as cores"), a
   pagina sobe sozinha ate ao inicio da galeria, ja com a cor nova.
   - so' no telemovel/tablet (ate 989px, o mesmo corte do pe-colour-swap.js);
   - so' com toque/clique real (e.isTrusted): os .click() feitos por codigo
     do tema nao mexem na pagina;
   - so' se o inicio da galeria estiver escondido por cima do ecra;
   - desconta o cabecalho quando ele fica fixo no topo;
   - respeita "reduzir movimento" do sistema.
   Espera que o pe-colour-swap.js acabe de reconstruir a galeria (ate 140ms). */
(function () {
  'use strict';
  if (!document.body || !document.body.classList.contains('t-product')) return;

  var MQ = '(max-width: 989px)';

  function headerOffset() {
    var h = document.querySelector('.site-header');
    if (!h) return 0;
    var el = h;
    while (el && el !== document.body) {
      var p = '';
      try { p = getComputedStyle(el).position; } catch (e) {}
      if (p === 'fixed' || p === 'sticky') {
        return Math.max(0, Math.round(h.getBoundingClientRect().height));
      }
      el = el.parentElement;
    }
    return 0;
  }

  function goToGallery() {
    if (!window.matchMedia || !window.matchMedia(MQ).matches) return;
    var g = document.getElementById('galSlider');
    if (!g) return;
    var off = headerOffset();
    var top = g.getBoundingClientRect().top;
    if (top >= off - 2) return;
    var y = Math.max(0, Math.round(window.pageYOffset + top - off - 8));
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try { window.scrollTo({ top: y, behavior: calm ? 'auto' : 'smooth' }); }
    catch (e) { window.scrollTo(0, y); }
  }

  /* v36 Fase 3AC (3W-02): so' sobe quando a cor foi escolhida com toque ou rato.
     Com o teclado (Enter/Espaco) o clique chega sem toque/clique antes; a pagina
     deixava de mostrar a cor com o foco. Agora fica onde esta. */
  var ptrEl = null, ptrAt = 0;
  function notePtr(e) {
    ptrEl = (e.target && e.target.closest) ? e.target.closest('.gs-color-thumb, .pe-cs-item') : null;
    ptrAt = Date.now();
  }
  document.addEventListener('pointerdown', notePtr, { capture: true, passive: true });
  document.addEventListener('touchstart', notePtr, { capture: true, passive: true });
  document.addEventListener('mousedown', notePtr, { capture: true, passive: true });

  document.addEventListener('click', function (e) {
    if (!e.isTrusted || !e.target || !e.target.closest) return;
    var t = e.target.closest('.gs-color-thumb, .pe-cs-item');
    if (!t) return;
    if (t !== ptrEl || Date.now() - ptrAt > 1500) return;
    setTimeout(goToGallery, t.classList.contains('pe-cs-item') ? 380 : 220);
  }, false);
})();

/* v36 Fase 3AC (3W-03) - CORES NA FICHA DE PRODUTO: FOCO DO TECLADO DIFERENTE DA COR ESCOLHIDA
   A cor escolhida tem um contorno preto fino por fora (pe-colour-swap.js). O foco do teclado usava o
   mesmo contorno, por isso nao se distinguia. Agora o foco e' um anel azul por dentro da miniatura
   (azul de foco #005FCC + linha branca), que nao mexe no tamanho nem na posicao. A cor escolhida fica
   igual. So' com :focus-visible (teclado); o toque e o rato nao mostram o anel.
   As cores esgotadas tem o botao a 50% de opacidade, o que deixava o anel quase sem contraste: so'
   enquanto tem o foco do teclado o botao fica a 100% (a foto continua esbatida, a mostrar que esgotou). */
(function () {
  'use strict';
  if (document.getElementById('pe-3ac-focus')) return;
  var S = 'html body:not(#pe-ds):not(#pe-v35):not(#pe-3ac) .gs-color-section.pe-cs .gs-color-thumb.pe-tile';
  var s = document.createElement('style');
  s.id = 'pe-3ac-focus';
  s.textContent = S + ':focus-visible:not(.on){outline-color:transparent !important}' +
    S + ':focus-visible{box-shadow:inset 0 0 0 3px #005FCC,inset 0 0 0 5px #fff !important}' +
    S + '.gs-color-thumb--soldout:focus-visible{opacity:1 !important}';
  (document.head || document.documentElement).appendChild(s);
})();

/* v36 Fase 3Q - CORES NOS CARTOES: AREA DE TOQUE DE 24x24px SEM SOBREPOSICAO
   As bolinhas de cor dos cartoes tem 14x14px. Ja tinham uma area invisivel de 30x30px (pe-b3c.css,
   ::after com inset -8px), mas o overflow:hidden da bolinha cortava-a (so os 14px respondiam) e, mesmo
   sem o corte, com 6px de intervalo essas areas sobrepunham-se. Agora a area invisivel tem exatamente 24x24px e o intervalo passa de 6 para 10px,
   para os centros ficarem a 24px e as areas nao se tocarem. A bolinha visivel nao muda de tamanho.
   Fica aqui (e nao no pacote CSS) porque o pacote pe-b3c.css e gerado e nao se edita a mao. */
(function () {
  'use strict';
  if (document.getElementById('pe-3q-cards')) return;
  var s = document.createElement('style');
  s.id = 'pe-3q-cards';
  s.textContent = 'html body:not(#pe-ds):not(#pe-3q) .product-card .pc-foot .pc-variant-thumbs{gap:10px !important}' +
    'html body .product-card .pc-vthumb::after{inset:-5px !important}' +
    /* a bolinha tinha overflow:hidden, que cortava a area invisivel (::after) - na pratica so os 14px
       visiveis respondiam ao toque. Passa a visivel; a foto la dentro fica recortada pelo proprio raio. */
    'html body:not(#pe-ds):not(#pe-3q) .product-card .pc-vthumb{overflow:visible !important}' +
    'html body:not(#pe-ds):not(#pe-3q) .product-card .pc-vthumb img{border-radius:inherit !important}';
  (document.head || document.documentElement).appendChild(s);
})();
